import gql from "graphql-tag";

export const List = gql`
query Teams {
  listMyTeams {
    items {
      teamId
      name
      robotName
      robotNumber
      eventId
      event {
        id
        title
        beginDate
      }
      competition {
        id: competitionId
        code
        i18n_title
        teamMemberLimit
      }
      members
      purchaseOrders {
        purchaseOrderId
        status
      }
      payments {
        paymentId
        voistlus
        success
        total
      }
      technicalControl {
        status
      }
    }
  } 
}
`;

export const Get = gql`
query GetMyTeam($teamId: ID!) {
  getMyTeam(teamId: $teamId) {
      teamId
      userId
      name
      robotName
      robotNumber
      hasAcceptedCompetitionRules
      eventId
      event {
        id
        title
      }
      competition {
        id: competitionId
        code
        i18n_title
        teamMemberLimit
        rulesurl: competitionRulesURL
      }
      mentor
      members
      createdBy
      createdAt
      purchaseOrders {
        purchaseOrderId
        status
      }
      payments {
        paymentId
        voistlus
        success
        total
      }
      technicalControl {
        status
        comments
        createdAt
      }
    }
}
`;


export const ListEvents = gql`
query listEvents {
  listEvents {
      value: id
      text: title
      location
      registrationEnabled
      type
      competitions {
        id: competitionId
        code
        date 
  	competitionRulesURL 
     	teamMemberLimit
      	robotRequired
      	published
        difficulty
        i18n_title
        i18n_description
      }
    }
}
`;

export const Create = gql`
  mutation CreateMyTeam($input: CreateMyTeamInput!) {
    createMyTeam(input: $input) {
      competitionId
      eventId
      name
      robotName
      hasAcceptedCompetitionRules
      mentor
      members
    }
  }
`;

export const Update = gql`
  mutation UpdateMyTeam($input: UpdateMyTeamInput!) {
    updateMyTeam(input: $input) {
      teamId
      competitionId
      eventId
      name
      robotName
      hasAcceptedCompetitionRules
      mentor
      members
    }
  }
`;

export const Delete = gql`
  mutation DeleteMyTeam($teamId: ID!) {
    deleteMyTeam(teamId: $teamId) {
      teamId
    }
  }
`;



// WEBPACK FOOTER //
// ./src/private/user/containers/Teams/graphql.js